import { requiredFieldsOf } from "@shared/validation/firestoreDocumentFields.js";
import { DocumentReference, Timestamp } from "firebase/firestore";
import { DataCollectionConfig } from "./dataCollectionConfig.js";

export interface Task {
  id?: string;
  name: string;
  description?: string;
  dataCollectionConfigs: DataCollectionConfig[];
  state: "completed" | "in-progress" | "planned";
  startDate: Timestamp;
  endDate?: Timestamp;
  metadata?: Record<string, any>;
  createdAt: Timestamp;
  createdBy: DocumentReference;
  updatedAt: Timestamp;
  updatedBy: DocumentReference;
}

/**
 * Every field a stored task must carry, derived from `Task` itself.
 *
 * A task missing `state` does not fail on write — Firestore drops undefined
 * fields — it blanks the entire experiment route on read, because the task list
 * renders `task.state.charAt(0)`. Observed, not theoretical.
 *
 * Adding a required property to `Task` will fail the build here until it is
 * listed, which keeps the interface the single source of truth.
 */
export const TASK_REQUIRED_FIELDS = requiredFieldsOf<Task>()([
  "name",
  "dataCollectionConfigs",
  "state",
  "startDate",
  "createdAt",
  "createdBy",
  "updatedAt",
  "updatedBy",
] as const);
